export class SelectionItem {
  constructor(
    public id: any,
    public value: string,
    public disabled?: boolean,
    public invalid?: boolean
  ) {}
}
